<template>
  <div>
    <b-row>
      <b-col v-show="showComboBanco" sm="3">
        <b-form-group label="Banco">
          <input-select
            v-model="model.banco"
            single
            :options="bancos"
            :required="bancoRequired"
            @input="loadComboParceiros"
          />
        </b-form-group>
      </b-col>

      <b-col :sm="!showComboBanco ? '5' : '3'">
        <b-form-group
          :label="titleComboParceiro ? titleComboParceiro : 'Parceiro'"
        >
          <input-select
            v-model="model.parceiro"
            single
            :options="parceiros"
            :disabled="!model.banco"
            placeholder="Todos"
            :required="parceiroRequired"
          />
        </b-form-group>
      </b-col>

      <b-col v-show="showAgenciaConta" sm="2">
        <b-form-group label="Agência">
          <input-select
            v-model="model.agencia"
            single
            :options="agencias"
            placeholder="Todas"
            :disabled="!model.parceiro || !model.banco"
            :required="agenciaRequired"
            @input="changeAgencia"
          />
        </b-form-group>
      </b-col>
      <b-col sm="2">
        <b-form-group label="Modelo Conta">
          <input-select
            v-model="model.modeloConta"
            single
            :options="$api.Arrays.ModeloConta"
            placeholder="Todos"
            :disabled="!model.agencia || !model.parceiro"
            @input="changeModeloConta"
          />
        </b-form-group>
      </b-col>
      <b-col sm="2">
        <b-form-group label="Conta">
          <input-select
            v-model="model.contaCombo"
            :search="pesquisaConta"
            :options="contas"
            placeholder="Todas"
            :disabled="!model.agencia || !model.parceiro"
            :required="contaRequired"
          />
        </b-form-group>
      </b-col>
    </b-row>

    <b-row v-if="showInfoCorrentista">
      <b-col sm="6">
        <b-form-group label="Cliente">
          <b-input v-model="modelCorrentista.nome" disabled />
        </b-form-group>
      </b-col>

      <b-col sm="3">
        <b-form-group label="Documento Federal">
          <input-documento
            v-model="modelCorrentista.documentoFederal"
            disabled
          />
        </b-form-group>
      </b-col>

      <b-col sm="2">
        <b-form-group label="Tipo Pessoa">
          <b-form-select
            v-model="modelCorrentista.tipoPessoa"
            :options="$api.Arrays.TiposPessoa"
            disabled
          />
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col v-if="showData && showDataInicial" sm="3">
        <b-form-group :label="dtIniText">
          <kendo-datepicker
            v-model="model.dtInicio"
            v-mask="'##/##/####'"
            :max="dtMax"
            :format="'dd/MM/yyyy'"
            :required="requiredData && dataInicialRequired"
          />
        </b-form-group>
      </b-col>

      <b-col v-if="showData && showDataFinal" sm="3">
        <b-form-group :label="dtFimText">
          <kendo-datepicker
            v-model="model.dtFim"
            v-mask="'##/##/####'"
            :min="dtMin"
            :max="new Date()"
            :format="'dd/MM/yyyy'"
            :required="requiredData && dataFinalRequired"
          />
        </b-form-group>
      </b-col>

      <b-col v-if="showDataBase" sm="3">
        <b-form-group label="Data Base">
          <input-date v-model="model.dtBase"/>
        </b-form-group>
      </b-col>

      <b-col v-if="comboOperacoes" sm="6">
        <b-form-group label="Operações">
          <input-multiselect v-model="model.operacoes" :options="operacoes" />
        </b-form-group>
      </b-col>

      <b-col v-if="comboContaBloqueio" sm="3">
        <b-form-group label="Situação Bloqueio Saldo">
          <input-select
            v-model="model.situacaoBloqueio"
            :options="$api.Arrays.SituacaoBloqueioConta"
            single
          />
        </b-form-group>
      </b-col>

      <b-col v-if="comboContaSaldo" sm="3">
        <b-form-group label="Situação Saldo">
          <input-select
            v-model="model.situacaoSaldo"
            :options="$api.Arrays.SituacaoSaldoConta"
            single
          />
        </b-form-group>
      </b-col>

      <b-col v-if="motivoEncerramento" sm="3">
        <b-form-group label="Motivo Encerramento">
          <input-select
            v-model="model.motivoEncerramento"
            :options="$api.Arrays.MotivoEncerramento"
            single
          />
        </b-form-group>
      </b-col>

      <b-col v-if="situacaoReivindicacaoDoacao" sm="3">
        <b-form-group label="Situação Portabilidade">
          <input-select
            v-model="model.situacaoReivindicacaoDoacao"
            :options="$api.Arrays.SituacoesReivindicacoesDoacoes"
            single
          />
        </b-form-group>
      </b-col>

      <b-col v-if="situacaoTarifa" sm="3">
        <b-form-group label="Situação">
          <input-select
            v-model="model.situacaoTarifa"
            :options="$api.Arrays.SituacaoTransacaoDescricao"
            single
            :required="requiredSituacaoTarifa"
          />
        </b-form-group>
      </b-col>

      <b-col v-if="origemTransacaoPix" sm="3">
        <b-form-group label="Origem Transação Pix">
          <input-select
            v-model="model.origemTransacaoPix"
            :options="optionsOrigemTransacaoPix"
            single
            required
          />
        </b-form-group>
      </b-col>

      <b-col v-if="showGestaoConta" sm="3">
        <b-form-group label="Indicação">
          <input-select
            v-model="model.codigoIndicador"
            :options="comboIndicadores"
            single
            placeholder="Todos"
          />
        </b-form-group>
      </b-col>

      <b-col v-if="showGestaoConta" sm="3">
        <b-form-group label="Carteira Conta">
          <input-select
            v-model="model.codigoCarteira"
            :options="comboCarteiras"
            single
            placeholder="Todas"
          />
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <slot name="extraBtns"></slot>
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    showData: { type: Boolean, default: true },
    showDataInicial: { type: Boolean, default: true },
    showDataFinal: { type: Boolean, default: true },
    comboOperacoes: { type: Boolean, default: false },
    showDataBase: { type: Boolean, default: false },
    comboContaBloqueio: { type: Boolean, default: false },
    comboContaSaldo: { type: Boolean, default: false },
    showComboBanco: { type: Boolean, default: true },
    parceiroSelected: { type: Boolean, default: false },
    value: { type: Object },
    dtIniText: { type: String, default: 'Data Inicial' },
    dtFimText: { type: String, default: 'Data Final' },
    requiredData: { type: Boolean, default: true },
    dataInicialRequired: { type: Boolean, default: true },
    dataFinalRequired: { type: Boolean, default: true },
    contaAtivas: { type: Boolean, default: false },
    todosParceiros: { type: Boolean, default: false },
    contaRequired: { type: Boolean, default: false },
    bancoRequired: { type: Boolean, default: true },
    agenciaRequired: { type: Boolean, default: false },
    parceiroRequired: { type: Boolean, default: false },
    titleComboParceiro: { type: String, default: null },
    showInfoCorrentista: { type: Boolean, default: false },
    motivoEncerramento: { type: Boolean, default: false },
    situacaoReivindicacaoDoacao: { type: Boolean, default: false },
    situacaoTarifa: { type: Boolean, default: false },
    operacoesRecorrente: { type: Boolean, default: false },
    autoSelectAgencia: { type: Boolean, default: false },
    requiredSituacaoTarifa: { type: Boolean, default: true },
    origemTransacaoPix: { type: Boolean, default: false },
    showAgenciaConta: { type: Boolean, default: true },
    showGestaoConta: { type: Boolean, default: false }
  },
  emits: ['refresh', 'input'],
  data() {
    return {
      bancos: [],
      agencias: [],
      contas: [],
      parceiros: [],
      operacoes: [],
      modelCorrentista: {},
      comboIndicadores: [],
      comboCarteiras: []
    }
  },
  computed: {
    optionsOrigemTransacaoPix() {
      var origemTransacoesPixPermitidos = [5, 505, 1006]
      return this.$api.Arrays.OrigemTransacao.filter((e) =>
        origemTransacoesPixPermitidos.includes(e.value)
      );
    },
    dtMin() {
      return this.model.dtInicio
        ? kendo.parseDate(this.model.dtInicio)
        : new Date('1970-01-01Z00:00:00:000')
    },
    dtMax() {
      return this.model.dtFim ? kendo.parseDate(this.model.dtFim) : new Date()
    },
    model: {
      get() {
        var obj = this.value
        return obj
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  watch: {
    'model.contaCombo': function (val) {
      if (val) {
        this.$set(this.model, 'conta', val.value)
        this.$set(this.model, 'contaText', val.text)
      } else {
        this.$set(this.model, 'conta', null)
        this.$set(this.model, 'contaText', null)
      }
      this.changeConta(val)
      this.$emit('refresh')
    },
    'model.parceiro': function (val) {
      if (val) {
        let parceiroText = this.parceiros.find((x) => x.value === val).text
        this.$set(this.model, 'parceiroText', parceiroText)
      } else {
        this.$set(this.model, 'parceiroText', null)
      }

      this.loadComboAgencias(val)
      this.$emit('refresh')
    },
    'model.agencia': function (val){
      if (val) {
        let agenciaText = this.agencias.find((x) => x.value === val).text
        this.$set(this.model, 'agenciaText', agenciaText)
      } else {
        this.$set(this.model, 'agenciaText', null)
      }
    },
  },
  created() {
    this.pesquisaConta = _.debounce(this.loadComboContas, 300)
  },
  beforeMount() {
    let th = this

    if (th.comboOperacoes) th.loadComboOperacoes()
    else th.loadComboBancos()

    if (th.showGestaoConta) {
      th.loadComboCarteirasConta()
      th.loadComboIndicadoresConta()
    }
  },
  methods: {
    getModelCorrentista() {
      return this.modelCorrentista
    },
    loadComboOperacoes() {
      let th = this
      let dto = {}

      if (th.operacoesRecorrente) {
        dto = {
          parameters: [
            { name: 'recorrente', value: th.operacoesRecorrente },
            { name: 'tipoBuscaOperacao', value: 2 },
          ],
        }
      }

      th.$api.Operacoes.GetAll(dto).then((response) => {
        th.loadComboBancos()
        th.operacoes = []
        th.$set(th.model, 'operacao', null)
        if (th.$api.UI.PostLoadData(response)) {
          response.forEach((item) => {
            let operacao = {
              value: item.codigo,
              text: item.identificador + ' - ' + item.descricao,
            }
            th.operacoes.push(operacao)
          })
        }
      })
    },
    loadComboAgencias(parceiro) {
      this.$set(this.model, 'agencia', null)
      this.$set(this.model, 'conta', null)

      if (!parceiro) return
      let th = this

      let dto = {
        parameters: [
          { name: 'codigoBanco', value: th.model.banco },
          { name: 'codigoParceiro', value: parceiro },
        ],
      }

      th.$api.Agencias.GetAll(dto).then((data) => {
        th.agencias = []
        th.$set(th.model, 'agencia', null)
        if (th.$api.UI.PostLoadData(data)) {
          if (!data.length || data.length === 0) {
            th.$api.UI.ShowError(
              'Erro',
              'Não existem agências cadastradas para este banco ou parceiro.'
            )
          } else {
            data.forEach((item) => {
              th.agencias.push({
                value: item.codigo,
                text: item.numero + '-' + item.digito + ' ' + item.nome,
              })
            })

            if (
              th.autoSelectAgencia &&
              data[0].numero === '0001' &&
              +data[0].digito === 8
            ) {
              th.$set(th.model, 'agencia', data[0].codigo)
            }
          }
        }
      })
    },
    loadComboBancos() {
      let th = this

      let dto = {}
      th.$api.Bancos.GetBancosInternos(dto).then((data) => {
        th.bancos = []
        th.$set(th.model, 'banco', null)
        if (th.$api.UI.PostLoadData(data)) {
          data.forEach((item) => {
            let banco = {
              value: item.codigo,
              text: item.numero + ' - ' + item.descricao,
            }
            th.bancos.push(banco)
          })

          th.$set(
            th.model,
            'banco',
            data.find((e) => e.numero === process.env.VUE_APP_BANCO).codigo
          )
        }
      })
    },
    changeAgencia() {
      let th = this

      th.$nextTick(() => {
        th.loadComboContas()
      })
    },
    changeModeloConta() {
      let th = this

      th.model.contaCombo = null

      th.$nextTick(() => {
        th.loadComboContas()
      })
    },
    loadComboContas(conta) {
      let th = this

      if (th.model.agencia) {
        if (!conta && th.model.contaCombo) conta = th.model.contaCombo.text

        let dto = {
          parameters: [
            { name: 'codigoAgencia', value: th.model.agencia },
            { name: 'codigoParceiro', value: th.model.parceiro },
            { name: 'situacaoConta', value: th.contaAtivas },
            { name: 'numeroConta', value: conta },
            { name: 'modeloConta', value: th.model.modeloConta },
          ],
        }

        if (!dto) return

        th.$api.Contas.ComboContas(dto).then((data) => {
          if (data) {
            if (!data.length || data.length === 0) {
              th.$api.UI.ShowError(
                'Erro',
                'Não foram encontradas contas com os parâmetros informados.'
              )
            } else {
              let arrayContas = []
              data.forEach((item) => {
                arrayContas.push({
                  value: item.codigo,
                  text: item.contaPgto,
                })
              })

              th.$nextTick(() => {
                th.contas = arrayContas
              })
            }
          }
        })
      } else {
        th.$set(this, 'contas', [])
        th.$set(this.model, 'contaCombo', null)
      }
    },
    loadComboParceiros() {
      let th = this
      th.$api.Parceiros.GetAll().then((response) => {
        th.parceiros = []
        th.$set(th.model, 'parceiro', null)
        if (Array.isArray(response)) {
          if (th.todosParceiros) {
            if (!th.parceiros.find((o) => o.text === 'Todos' && !!o.value)) {
              th.parceiros.unshift({ value: 0, text: 'Todos' })
            }

            th.$set(th.model, 'parceiro', 0)
          }
          response.forEach((item) => {
            let parceiro = {
              value: item.codigo,
              text: item.nome.concat(
                ' ',
                '(CNPJ: ',
                th.$api.UI.Format.DocumentoFederal(item.documentoFederal),
                ')'
              ),
            }

            th.parceiros.push(parceiro)
          })

          if (th.parceiroSelected) {
            th.$set(th.model, 'parceiro', response[0].codigo)
          }
        }
      })
    },
    loadComboIndicadoresConta() {
      let th = this
      th.$api.AdministradorConta.GetAll().then(function (data) {
        if (Array.isArray(data)) {
          data.forEach(function (item) {
            if (item.tipoAgente === 2) {
              th.comboIndicadores.push({
                value: item.codigo,
                text: item.agente
              })
            }
          })
        }
      })
    },
    loadComboCarteirasConta() {
      let th = this
      th.$api.CarteiraConta.GetAll().then(function (data) {
        if (Array.isArray(data)) {
          data.forEach(function (item) {
            if (item.situacao === 1) {
              th.comboCarteiras.push({
                value: item.codigo,
                text: item.carteira
              })
            }
          })
        }
      })
    },
    changeConta(val) {
      let th = this
      th.modelCorrentista.nome = ''
      th.modelCorrentista.documentoFederal = ''
      th.modelCorrentista.tipoPessoa = null

      if (val && val.value && th.showInfoCorrentista) {
        th.$api.ContaCorrentistas.GetCorrentistaTitular(val.value).then(
          (response) => {
            if (th.$api.UI.PostAction(response, '', false)) {
              th.modelCorrentista.nome = response.nome
              th.modelCorrentista.documentoFederal =
                th.$api.UI.Format.DocumentoFederal(response.documentoFederal)
              th.modelCorrentista.tipoPessoa = response.tipoPessoa
              th.modelCorrentista = Object.assign({}, th.modelCorrentista)
            }
          }
        )
      }
    },
    refresh() {
      this.$emit('refresh')
    }
  }
}
</script>
